export const mutations = {
    setBanco(state, banco) {
        state.banco = banco
    },
    setBancos(state, bancos) {
        state.bancos = bancos
    },
    addBanco(state, data){
        state.bancos.push(data)
    },
    removeBanco(state, data){
        let index = state.bancos.map(x => x.id).indexOf(data.id);
        state.bancos.splice(index, 1)
    },
    setModalCadastrarBanco(state, status) {
        state.modalCadastrarBanco = status
    },
    setModalExcluirBanco(state, status) {
        state.modalExcluirBanco = status
    },
}

export default {}